export default function Tr({children}) {
  return (
      <tr className=" hover:bg-gray-50 dark:bg-slate-900 dark:hover:bg-slate-800">
        {children}
      </tr>
  )
}